﻿(function () {
    if (window.__liaisonWebsiteChatInitialised) return;
    window.__liaisonWebsiteChatInitialised = true;

    const toggle = document.getElementById('chat-toggle');
    const closeBtn = document.getElementById('chat-close');
    const panel = document.getElementById('chat-panel');
    const send = document.getElementById('chat-send');
    const input = document.getElementById('chat-input');
    const messages = document.getElementById('chat-messages');

    if (!toggle || !closeBtn || !panel || !send || !input || !messages) return;

    const productSlug = document.body.getAttribute('data-product-slug') || null;

    const STORAGE_KEY = 'liaison_chat_history';
    const CHAT_STATE_KEY = 'liaison_chat_open';
    const CHAT_SCROLL_KEY = 'liaison_chat_scroll';

    const history = [];
    let greetingShown = false;
    let isRestoringHistory = false;
    let isSending = false;

    function scrollMessageToTop(row) {
        if (!row) return;

        requestAnimationFrame(() => {
            const top = row.offsetTop - messages.offsetTop;
            messages.scrollTo({
                top: top,
                behavior: 'smooth'
            });
            saveChatScroll();
        });
    }

    function saveChat() {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    }

    function saveChatState(isOpen) {
        localStorage.setItem(CHAT_STATE_KEY, isOpen ? 'open' : 'closed');
    }

    function saveChatScroll() {
        localStorage.setItem(CHAT_SCROLL_KEY, messages.scrollTop.toString());
    }

    function restoreChatScroll() {
        const saved = localStorage.getItem(CHAT_SCROLL_KEY);
        if (!saved) return;

        requestAnimationFrame(() => {
            messages.scrollTop = parseInt(saved, 10) || 0;
        });
    }

    function loadChat() {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (!saved) return;

        try {
            const parsed = JSON.parse(saved);
            if (!Array.isArray(parsed) || parsed.length === 0) return;

            isRestoringHistory = true;

            parsed.forEach(msg => {
                renderMessage(
                    msg.role,
                    msg.content,
                    msg.nextSteps || [],
                    msg.brochureUrl || null,
                    msg.timestamp || null
                );

                history.push({
                    role: msg.role,
                    content: msg.content,
                    nextSteps: msg.nextSteps || [],
                    brochureUrl: msg.brochureUrl || null,
                    timestamp: msg.timestamp || null
                });
            });

            if (history.length > 0) {
                greetingShown = true;
            }

            isRestoringHistory = false;
        } catch {
            isRestoringHistory = false;
            localStorage.removeItem(STORAGE_KEY);
        }
    }

    function openChat() {
        panel.classList.remove('is-closing');
        panel.classList.add('is-open');
        toggle.classList.add('is-hidden');
        saveChatState(true);
        showGreeting();

        setTimeout(() => {
            input.focus();
        }, 180);
    }

    function closeChat() {
        panel.classList.remove('is-open');
        panel.classList.add('is-closing');
        toggle.classList.remove('is-hidden');
        saveChatState(false);

        setTimeout(() => {
            panel.classList.remove('is-closing');
        }, 320);
    }

    function restoreChatState() {
        const savedState = localStorage.getItem(CHAT_STATE_KEY);

        if (savedState === 'open') {
            panel.classList.add('is-open');
            panel.classList.remove('is-closing');
            toggle.classList.add('is-hidden');
        } else {
            panel.classList.remove('is-open', 'is-closing');
            toggle.classList.remove('is-hidden');
        }
    }

    function autoResizeTextarea(el) {
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 120) + 'px';
    }

    function getButtonClass(style) {
        switch (style) {
            case 'primary':
                return 'btn btn-sm btn-primary';
            case 'warning':
                return 'btn btn-sm btn-warning';
            default:
                return 'btn btn-sm btn-outline-primary';
        }
    }

    function applyInlineFormatting(text) {
        if (!text) return '';

        return text
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    }

    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function normalisePricingText(text) {
        if (!text) return '';

        let normalised = text.replace(/\r/g, '').trim();

        const tierNames = [
            'Essential',
            'Standard',
            'Premium',
            'Custom',
            'Starter',
            'Professional',
            'Enterprise',
            'Basic'
        ];

        const tierPattern = new RegExp(`\\s-\\s(?=(${tierNames.join('|')}):)`, 'gi');
        normalised = normalised.replace(tierPattern, '\n- ');
        normalised = normalised.replace(/:\s*-\s+/g, ':\n- ');

        return normalised;
    }

    function formatMessage(text) {
        const preprocessed = normalisePricingText(text || '');
        const safeText = applyInlineFormatting(escapeHtml(preprocessed));
        const lines = safeText.split(/\r?\n/);

        let html = '';
        let paragraphLines = [];
        let listItems = [];

        function flushParagraph() {
            if (paragraphLines.length > 0) {
                const paragraphText = paragraphLines.join('<br>');
                html += `<p>${paragraphText}</p>`;
                paragraphLines = [];
            }
        }

        function flushList() {
            if (listItems.length > 0) {
                html += '<ul>';
                listItems.forEach(item => {
                    html += `<li>${item}</li>`;
                });
                html += '</ul>';
                listItems = [];
            }
        }

        lines.forEach(line => {
            const trimmed = line.trim();

            if (trimmed === '') {
                flushParagraph();
                flushList();
                return;
            }

            if (trimmed.startsWith('- ')) {
                flushParagraph();
                listItems.push(trimmed.substring(2).trim());
                return;
            }

            if (trimmed.startsWith('• ')) {
                flushParagraph();
                listItems.push(trimmed.substring(2).trim());
                return;
            }

            flushList();
            paragraphLines.push(trimmed);
        });

        flushParagraph();
        flushList();

        return html || '<p></p>';
    }

    function formatTimestamp(iso) {
        if (!iso) return '';

        const date = new Date(iso);

        if (Number.isNaN(date.getTime())) return '';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const mins = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${mins}`;
    }

    function createBrochureHtml(brochureUrl) {
        if (!brochureUrl) return '';

        const safeUrl = escapeHtml(brochureUrl);

        return `
            <p class="chat-brochure-link">
                You can download the product brochure here:
                <a href="${safeUrl}" class="link-primary ms-1" target="_blank" rel="noopener">
                    <i class="fa-solid fa-file-arrow-down me-1"></i> Download
                </a>
            </p>`;
    }

    function renderMessage(role, text, nextSteps, brochureUrl, timestamp) {
        const row = document.createElement('div');
        row.className = 'chat-msg ' + (role === 'user' ? 'chat-msg-user' : 'chat-msg-assistant');

        const label = role === 'user' ? 'You' : 'Liaison Systems Ltd';
        const formattedTimestamp = formatTimestamp(timestamp);

        const meta = document.createElement('div');
        meta.className = 'chat-meta';
        meta.innerHTML = formattedTimestamp
            ? `<span class="chat-meta-name">${label}</span> <span class="chat-meta-time">${formattedTimestamp}</span>`
            : `<span class="chat-meta-name">${label}</span>`;

        row.appendChild(meta);

        const bubble = document.createElement('div');
        bubble.className = 'chat-bubble';
        bubble.innerHTML = formatMessage(text);

        if (role === 'assistant' && brochureUrl) {
            bubble.innerHTML += createBrochureHtml(brochureUrl);
        }

        row.appendChild(bubble);

        if (nextSteps && nextSteps.length > 0) {
            const wrap = document.createElement('div');
            wrap.className = 'chat-next-steps';

            nextSteps.forEach(step => {
                if (!step.label || !step.url) return;

                const link = document.createElement('a');
                link.href = step.url;
                link.className = getButtonClass(step.style);
                link.textContent = step.label;
                wrap.appendChild(link);
            });

            if (wrap.childElementCount > 0) {
                row.appendChild(wrap);
            }
        }

        messages.appendChild(row);
        return row;
    }

    function addMessage(role, text, nextSteps, brochureUrl, timestamp) {
        const messageTimestamp = timestamp || new Date().toISOString();
        const row = renderMessage(role, text, nextSteps, brochureUrl, messageTimestamp);

        if (!isRestoringHistory) {
            history.push({
                role: role,
                content: text,
                nextSteps: nextSteps || [],
                brochureUrl: brochureUrl || null,
                timestamp: messageTimestamp
            });

            saveChat();

            if (role === 'user') {
                messages.scrollTop = messages.scrollHeight;
                saveChatScroll();
            } else {
                scrollMessageToTop(row);
            }
        }
    }

    function addThinkingMessage() {
        const row = document.createElement('div');
        row.className = 'chat-msg';
        row.id = 'chat-loading';
        row.innerHTML = `
            <div class="chat-bubble">
                <div class="thinking" aria-label="Thinking">
                    <span class="thinking-dot"></span>
                    <span class="thinking-dot"></span>
                    <span class="thinking-dot"></span>
                </div>
            </div>`;
        messages.appendChild(row);
        messages.scrollTop = messages.scrollHeight;
        saveChatScroll();
    }

    function getRecentHistoryForSend() {
        return history
            .filter(x => x.role === 'user' || x.role === 'assistant')
            .slice(-6)
            .map(x => ({
                role: x.role,
                content: x.content
            }));
    }

    function showGreeting() {
        if (greetingShown || history.length > 0) return;

        greetingShown = true;

        addMessage(
            'assistant',
            `Hello 👋

            I can help answer questions about our products and services.

            You can ask things like:
            - Which product might suit our business?
            - What does this product do?
            - What are the next steps?
            - Can I arrange a demo?

            Type your question below and I’ll do my best to help.`,
            [
                { label: 'Contact Us', url: '/Contact', style: 'outline-primary' }
            ],
            null,
            new Date().toISOString()
        );
    }

    async function sendMessage() {
        if (isSending) return;

        const text = input.value.trim();
        if (!text) return;

        isSending = true;
        send.disabled = true;

        addMessage('user', text, [], null, new Date().toISOString());

        input.value = '';
        input.style.height = 'auto';

        addThinkingMessage();

        try {
            const response = await fetch('/api/chatbot/message', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    message: text,
                    productSlug: productSlug,
                    history: getRecentHistoryForSend()
                })
            });

            const data = await response.json();
            document.getElementById('chat-loading')?.remove();

            if (data.requiresChallenge) {
                addMessage(
                    'assistant',
                    data.challengeMessage || 'Please confirm you are a real visitor before continuing.',
                    [],
                    null,
                    new Date().toISOString()
                );
                return;
            }

            addMessage(
                'assistant',
                data.answer || 'Sorry, I could not answer that.',
                data.nextSteps || [],
                data.brochureUrl || null,
                new Date().toISOString()
            );
        } catch {
            document.getElementById('chat-loading')?.remove();
            addMessage(
                'assistant',
                'Sorry, something went wrong.',
                [],
                null,
                new Date().toISOString()
            );
        } finally {
            isSending = false;
            send.disabled = false;
        }
    }

    toggle.addEventListener('click', openChat);
    closeBtn.addEventListener('click', closeChat);
    send.addEventListener('click', sendMessage);

    messages.addEventListener('scroll', function () {
        saveChatScroll();
    });

    input.addEventListener('input', function () {
        autoResizeTextarea(this);
    });

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        loadChat();
        restoreChatState();
        restoreChatScroll();
        autoResizeTextarea(input);

        if (panel.classList.contains('is-open')) {
            showGreeting();
        }
    });
})();